export const api = {
    endpoints: {
        application_submit_url: '/applicant/add',
        get_property_url: '/property/applicant-option/property-id',
        upload_documenmts_url: '/applicant/upload-documents',
        upload_documents_temp_url: '/applicant/upload-documents-temp',
    }
};
